export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5025/api';
export const UPLOADS_URL = process.env.REACT_APP_UPLOADS_URL || 'http://localhost:5025/';
export const SOCKET_SERVER = process.env.REACT_APP_SOCKET_URL || 'http://localhost:5999/socket';
export const JWT_SECRET = '123456' || process.env.REACT_APP_JWT_SECRET;
export const INTERCOM_SERVICE_URL = process.env.REACT_APP_CONVERSATIONS_SERVICE || 'http://localhost:5004';